module.exports = __webpack_public_path__ + "media/demo1-jp.bcc96946.mp4";